import { ComingSoon } from "../../features/misc/coming-soon/coming-soon";
import { Careers } from "../../features/sale-site/careers/careers";

const CareersPage = () => {
  return <Careers />;
  // return <ComingSoon />;
};

export default CareersPage;
